<template>
    <form class="red-form form-horizontal" @submit.prevent="handleSubmit">
        <div class="form-group" :class="{ 'has-error': errors['opening_hours'] }" id="opening-hours-section">
            <label for="opening_hours" class="col-sm-2 control-label">Horas de apertura</label>
            <div class="col-sm-10">
                <opening-hours v-model="data.opening_hours" @setHasEmptySchedule="hasEmptySchedule = $event"
                    @scheduleErrors="handleScheduleErrors">
                </opening-hours>
                <div class="help-block" v-if="errors['opening_hours']">
                    {{ errors['opening_hours'][0] }}
                </div>
            </div>
        </div>

        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="/backend/red-de-atencion/call-center">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
.el-select {
    display: block;
}

.subtitle {
    color: #757575;
}

/* Asegurar que los labels no se vean afectados por has-error */
.form-group {
    &.has-error {
        .control-label.no-error {
            color: inherit !important;
        }
    }
}

/* Estilo específico para los inputs cuando hay error */
.has-error {

    .el-select,
    .el-time-select,
    .form-control {
        &:not(.no-error) {
            border-color: #a94442;
        }
    }
}
</style>
<script>
import OpeningHours from '../../../components/OpeningHours.vue';
import Vue from 'vue';

export default {

    data() {
        return {
            data: {
                opening_hours: this.openingHours, // This array should be initialized properly
            },
            disabled: false,
            errors: {},
            hasEmptySchedule: false,
            scheduleErrors: null,
            isSubmitting: false,
        };
    },
    props: {
        routeUrl: {
            type: String,
            required: true,
        },
        openingHours: {
            type: Array,
            default: () => []
        }
    },
    components: {
        OpeningHours,
    },
    methods: {
        handleScheduleErrors: _.debounce(function (errors) {
            if (!errors) {
                Vue.set(this.errors, 'opening_hours', []);
                return;
            }

            let errorMessage = '';
            // Primero verificamos el error de tiempo inválido
            if (errors.invalidTimes) {
                errorMessage = 'La hora de cierre debe ser posterior a la hora de apertura.';
            } else if (errors.emptyDays) {
                errorMessage = 'Por favor, seleccione al menos un día para todos los horarios.';
            } else if (errors.emptyTimes) {
                errorMessage = 'Por favor, seleccione las horas de apertura y cierre.';
            }

            if (errorMessage !== this.errors?.opening_hours?.[0]) {
                Vue.set(this.errors, 'opening_hours', [errorMessage]);
            }
        }, 300),

        isInvalidTimeRange(opens, closes) {
            if (!opens || !closes) return true;

            const [openHour, openMinute] = opens.split(':').map(Number);
            const [closeHour, closeMinute] = closes.split(':').map(Number);

            const openingMinutes = openHour * 60 + openMinute;
            const closingMinutes = closeHour * 60 + closeMinute;

            return openingMinutes >= closingMinutes;
        },

        scrollToError(elementId) {
            this.$nextTick(() => {
                const element = document.getElementById(elementId);
                if (element) {
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "center"
                    });
                }
            });
        },
        async handleSubmit(event) {
            event.preventDefault();

            // Reset errores al inicio
            this.errors = {};
            try {
                // Prevenir múltiples submits
                if (this.isSubmitting) {
                    return false;
                }
                // Validar que existan horarios
                if (!this.data.opening_hours?.length) {
                    Vue.set(this.errors, 'opening_hours', ['Debe agregar al menos un horario.']);
                    this.scrollToError('opening-hours-section');
                    return false;
                }
                // Validar cada horario
                const hasInvalidSchedule = this.data.opening_hours.some(schedule => {
                    return !schedule.dayOfWeek?.length ||
                        !schedule.opens ||
                        !schedule.closes ||
                        this.isInvalidTimeRange(schedule.opens, schedule.closes);
                });
                if (hasInvalidSchedule || this.hasEmptySchedule) {
                    Vue.set(this.errors, 'opening_hours', ['Por favor, complete correctamente todos los horarios.']);
                    this.scrollToError('opening-hours-section');
                    return false;
                }
                // Si llegamos aquí, las validaciones pasaron
                this.isSubmitting = true;
                const url = this.routeUrl;
                const method = 'PUT';

                const response = await axios({
                    url: url,
                    method: method,
                    data: this.data,
                });
                // Solo redirigir si la petición fue exitosa
                if (response.data?.redirect) {
                    window.location.replace(response.data.redirect);
                }

            } catch (error) {
                // Si es un error de axios
                if (error.response?.data?.errors) {
                    this.errors = error.response.data.errors;
                }
                // Si hay errores del servidor, scrollear al primer error
                if (error.response?.data?.errors) {
                    const firstErrorField = Object.keys(error.response.data.errors)[0];
                    const elementId = this.getElementIdForField(firstErrorField);
                    if (elementId) {
                        this.scrollToError(elementId);
                    }
                }
            } finally {
                this.isSubmitting = false;
            }

            return false;
        },

    },
};
</script>